Surveys.Views.Dashboard ||= {}

class Surveys.Views.Dashboard.ActionsView extends Backbone.View
  template: JST['backbone/templates/surveys/dashboard/actions']

  render: ->
    @$el.html @template
    @
